import { hardNavigate } from './utils'

export interface CommandHandler {
    handle: (query: string) => boolean
}

export interface FrontendCommand {
    shortcut: string
    name: string
    description: string
}

const GO_ROUTES: Record<string, string> = {
    research: '/research',
    searches: '/searches',
    companies: '/companies',
}

const goHandler: CommandHandler = {
    handle: (query) => {
        const match = query.match(/^@go\s+(\w+)$/i)
        if (!match) return false

        const destination = match[1].toLowerCase()
        const path = GO_ROUTES[destination]

        if (path) {
            hardNavigate(path)
            return true
        }

        return false
    },
}

const logoutHandler: CommandHandler = {
    handle: (query) => {
        if (query.trim().toLowerCase() !== '@logout') return false
        hardNavigate('/logout')
        return true
    },
}

export const COMMAND_HANDLERS: CommandHandler[] = [goHandler, logoutHandler]

export const FRONTEND_COMMANDS: FrontendCommand[] = [
    {
        shortcut: '@go',
        name: 'navigate',
        description: 'Go to a page (research, searches, companies)',
    },
    {
        shortcut: '@logout',
        name: 'logout',
        description: 'Log out of the application',
    },
    {
        shortcut: '@help',
        name: 'help',
        description: 'Show available commands',
    },
]

export function tryHandleCommand(query: string): boolean {
    for (const handler of COMMAND_HANDLERS) {
        if (handler.handle(query)) {
            return true
        }
    }
    return false
}
